import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FeedbackButton.css';

const FeedbackButton = ({ 
  type, 
  gameId, 
  gameName, 
  buttonText, 
  position = 'bottom-right',
  language = 'zh'
}) => {
  const navigate = useNavigate();

  // Map old type names to new database types
  const typeMapping = {
    unplayable: 'game_issue',
    inaccurate: 'info_error',
    manual_request: 'manual_request',
    manual_submission: 'manual_request',
    new_game: 'new_game',
    site_bug: 'site_bug',
    // Also support new types directly
    game_issue: 'game_issue',
    info_error: 'info_error'
  };

  const openFeedbackPage = () => {
    // Navigate to feedback page with pre-filled data
    const mappedType = typeMapping[type] || type;
    const params = new URLSearchParams({
      new: 'true',
      type: mappedType,
    });
    
    if (gameId) params.append('gameId', gameId);
    if (gameName) params.append('gameName', gameName);
    
    navigate(`/feedback?${params.toString()}`);
  };

  // Map feedback types to appropriate button text if not provided
  const defaultButtonText = {
    unplayable: language === 'en' ? 'Report Game Issue' : '反馈游戏问题',
    game_issue: language === 'en' ? 'Report Game Issue' : '反馈游戏问题',
    inaccurate: language === 'en' ? 'Report Information Error' : '报告信息错误',
    info_error: language === 'en' ? 'Report Information Error' : '报告信息错误',
    manual_request: language === 'en' ? 'Submit/Request Manual' : '提交/请求手册',
    manual_submission: language === 'en' ? 'Submit/Request Manual' : '提交/请求手册',
    new_game: language === 'en' ? 'Request New Game' : '请求新游戏',
    site_bug: language === 'en' ? 'Report Site Bug' : '报告网站Bug'
  };

  const text = buttonText || defaultButtonText[type] || (language === 'en' ? 'Feedback' : '反馈');

  return (
    <button 
      className={`feedback-button ${position}`} 
      onClick={openFeedbackPage}
      aria-label={text}
    >
      <span className="feedback-icon">
        <svg className="icon" viewBox="0 0 1024 1024" width="16" height="16">
          <path d="M800.037628 960.010751 223.962372 960.010751c-52.980346 0-95.983874-43.003528-95.983874-95.983874l0-639.892491c0-52.980346 43.003528-95.983874 95.983874-95.983874l447.924744 0c17.717453 0 31.994625 14.277171 31.994625 31.994625s-14.277171 31.994625-31.994625 31.994625L223.962372 192.139761c-17.545439 0-31.994625 14.449185-31.994625 31.994625l0 639.892491c0 17.717453 14.449185 31.994625 31.994625 31.994625l575.903242 0c17.717453 0 31.994625-14.277171 31.994625-31.994625L831.860239 351.94087c0-17.717453 14.277171-31.994625 31.994625-31.994625 17.717453 0 31.994625 14.277171 31.994625 31.994625l0 511.913993C896.021502 916.835209 852.84596 960.010751 800.037628 960.010751z" fill="#e4cb86" />
          <path d="M612.026205 447.924744c-8.256677 0-16.341341-3.096254-22.705863-9.460776-12.55703-12.55703-12.55703-32.682681 0-45.239711L907.374433 75.34218c12.55703-12.55703 32.682681-12.55703 45.239711 0s12.55703 32.682681 0 45.239711L634.560054 438.635982C628.367546 444.82849 620.110868 447.924744 612.026205 447.924744z" fill="#e4cb86" />
          <path d="M479.919368 447.924744 287.951621 447.924744c-17.717453 0-31.994625-14.277171-31.994625-31.994625s14.277171-31.994625 31.994625-31.994625L479.919368 383.935495c17.717453 0 31.994625 14.277171 31.994625 31.994625C511.913993 433.647573 497.636822 447.924744 479.919368 447.924744z" fill="#e4cb86" />
          <path d="M672.05913 639.892491 287.951621 639.892491c-17.717453 0-31.994625-14.277171-31.994625-31.994625s14.277171-31.994625 31.994625-31.994625l383.935495 0c17.717453 0 31.994625 14.277171 31.994625 31.994625S689.604569 639.892491 672.05913 639.892491z" fill="#e4cb86" />
        </svg>
      </span>
      <span className="feedback-text">{text}</span>
    </button>
  );
};

export default FeedbackButton; 